import axios from 'axios';

const api = '/api/birthday-nameday';

export const getBirthdayNameday = () => {
  return axios.get(`${api}?cacheBuster=${new Date().getTime()}`);
};
